import { Injectable, NgZone } from '@angular/core';
import { HttpService } from '../http.service';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { DesktopNotificationSegement } from 'src/app/_template/notifications/notifications.component';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth.service';
import { GeneralService } from '../general.service';


export interface DesktopNotification{
  id: number;
  description?: string
  action?: string
  date: Date
  ticketId: number
  ticketNumber: string
  workstepId?: number
  companyName?: number
  hasOpened: boolean
  hasSeen: boolean
  employeeName?: string
  preview?: string
}

@Injectable({
  providedIn: 'root'
})
export class DesktopNotificationsService {

  public notificationOpen: boolean = false 
  public notificationCloseAnimation: boolean = false

  public unseenNotifications: number[] = []

  constructor(
    private http: HttpService,
    private ngZone: NgZone,
    private authSrv: AuthService
  ) { 



    const httpReadySub: Subscription = this.http.requestReady.subscribe(async (ready: boolean) => {
      if(!ready) return
      httpReadySub.unsubscribe()
      // await this.loadUnseenNotificationCount()

      if(this.authSrv.isDemoMode) return 
      setInterval(async() => {
        if(this.authSrv.getUser().role?.includes("employee")) await this.loadUnseenNotificationCount()
      }, 60000);
    })

  }

  public openNotifications(){
    this.ngZone.run(() => {
      this.notificationOpen = true
      this.unseenNotifications = [] 
    })
  }

  private hidetimeout
  public hideNotifications(){
    this.ngZone.run(() => {
      this.notificationCloseAnimation = true
      clearTimeout(this.hidetimeout)
      this.hidetimeout = setTimeout(() => {
        this.notificationOpen = false
        this.notificationCloseAnimation = false
      }, 350);
    })
  }

  public async loadUnseenNotificationCount(){
    const result: HttpFunctionResult<number[]> = await this.http.GET({
      path: "notifications/unseen-count",
      handleError: false
    })
    if(result.success) this.unseenNotifications = result.data
    
  }

  /**
   * Lädt die Benachrichtigungen für den Benutzer
   * @param {number} offset Wie viele Benachrichtigungen übersprungen werden sollen
   * @param {number} limit Wie viele Benachrichtigungen geladen werden sollen
   * @param {DesktopNotificationSegement} filter Ob alle oder nur ungelesene Benachrichtigungen geladen werden sollen
   * @returns 
   */
  public async getNotificationsByUser(offset: number = 0, limit: number = 20, filter: DesktopNotificationSegement): Promise<HttpFunctionResult<DesktopNotification[]>>{
    return await this.http.GET({
      path: `notifications?offset=${offset}&limit=${limit}&filter=${filter}`
    });
  }

  /**
    * Markiert eine oder mehrere Benachrichtigungen als gelesen oder gesehen
   * @param {number[]} ids Die IDs der Benachrichtigungen
   * @param {string} param Ob die Benachrichtigungen als gelesen oder geöffnet markiert werden sollen
   * @returns 
   */
  public async markAsSeenOrRead(ids: number[], param: string = "seen"){
    return await this.http.PUT({
      path: `notifications?field=${param}`,
      body: ids
    })
  }




}
